import React from "react";
import { comparisonRows } from "../data/product";
import { Accent, SectionHeading } from "./ui/SectionHeading";
export function Comparison() {
  return <section className="bg-blush px-4 py-14 sm:px-6 sm:py-20" data-id="element-76" data-mp="1g68axe1oo2cd">
      <SectionHeading title={<>
            Comprati, o <Accent data-id="element-78" data-mp="1pynqk4piceu3">fatti da te</Accent>
          </>} subtitle="Lo stesso scaffale, due vasetti molto diversi." data-id="element-77" data-mp="1l6m5pue9xfsg" />
      <div className="mx-auto mt-8 max-w-2xl overflow-hidden rounded-[28px] border border-line bg-cream shadow-[0_18px_40px_-28px_rgba(86,18,54,0.5)]" data-id="element-79" data-mp="1uwfiuzu2e2yt">
        <table className="w-full table-fixed border-collapse text-center" data-id="element-80" data-mp="23xvpqxlo7mya">
          <thead data-id="element-81" data-mp="23vsrjqad6nih">
            <tr data-id="element-82" data-mp="28wzyxo8lhkom">
              <th scope="col" className="border-r border-line px-3 py-4 font-serif text-2xl font-semibold text-rose/60 sm:text-[28px]" data-id="element-83" data-mp="28xi4jbh5db97">
                Comprato
              </th>
              <th scope="col" className="px-3 py-4 font-serif text-2xl font-semibold text-rose sm:text-[28px]" data-id="element-84" data-mp="eiz4dfk2vjuc">
                Fatto da te
              </th>
            </tr>
          </thead>
          <tbody data-id="element-85" data-mp="1m2jv3jso4xgg">
            {comparisonRows.map(r => <tr key={r.made} className="border-t border-line" data-id="element-86" data-mp="1h8fqh76vl1ij">
                <td className="border-r border-line px-3 py-4 text-[14px] leading-snug text-muted sm:px-6 sm:text-base" data-id="element-87" data-mp="1d7vqlvux3jsp">
                  {r.bought}
                </td>
                <td className="px-3 py-4 text-[14px] font-semibold leading-snug text-wine sm:px-6 sm:text-base" data-id="element-88" data-mp="24zl55j12xnr9">
                  {r.made}
                </td>
              </tr>)}
            <tr className="border-t border-line" data-id="element-89" data-mp="20w5c0wo7y5jb">
              <td className="border-r border-line px-3 py-4 text-[14px] italic text-muted sm:text-base" data-id="element-90" data-mp="1vxu2yo5qzz25">“Dov'è che l'hai preso?”</td>
              <td className="px-3 py-4 text-[14px] font-semibold italic text-rose sm:text-base" data-id="element-91" data-mp="1r1wjwa33oelo">“L'ho fatto io.”</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}